/**
 * Root Reducer
 * 
 * Combines all feature-specific reducers into a single root reducer.
 * This is the main reducer that manages the entire application state.
 * 
 * State Structure:
 * {
 *   auth: Authentication state (user, token, loading, errors)
 *   alert: Global alert/notification state
 *   content: Unified content catalog and CRUD state
 * }
 */

import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../auth/authSlice';
import alertReducer from './alertSlice';
import { contentReducer } from '../features/content';

/**
 * Root reducer combining all feature reducers
 * 
 * Each reducer manages a specific slice of the application state:
 * - auth: Login, registration, authentication status
 * - alert: Global alert/notification state
 * - content: Unified content CRUD operations state
 */
const rootReducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  content: contentReducer,
});

export default rootReducer;
